import { render, staticRenderFns } from "./ApplicantFormSignUp.vue?vue&type=template&id=245055cb&scoped=true"
import script from "./ApplicantFormSignUp.vue?vue&type=script&lang=js"
export * from "./ApplicantFormSignUp.vue?vue&type=script&lang=js"
import style0 from "./ApplicantFormSignUp.vue?vue&type=style&index=0&id=245055cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245055cb",
  null
  
)

export default component.exports